export const ROUTE_FOCUS_SELECTOR = '[data-route-focus]';

export function moveFocusForRoute(main, { scrollTop = 0, restoreWhenReady = false } = {}) {
  if (!main) return;

  const scroll = () => main.scrollTo({ top: scrollTop, left: 0, behavior: 'instant' });
  scroll();
  const target = main.querySelector(ROUTE_FOCUS_SELECTOR) || main;
  target.focus({ preventScroll: true });

  if (!restoreWhenReady || scrollTop === 0 || typeof ResizeObserver === 'undefined') return undefined;

  let stopped = false;
  const stop = () => {
    if (stopped) return;
    stopped = true;
    observer.disconnect();
    clearTimeout(timeout);
    main.removeEventListener('wheel', stop);
    main.removeEventListener('touchstart', stop);
    main.removeEventListener('pointerdown', stop);
    main.removeEventListener('keydown', stop);
  };
  const restore = () => {
    if (stopped) return;
    scroll();
    if (Math.abs(main.scrollTop - scrollTop) <= 1) stop();
  };
  const observer = new ResizeObserver(restore);
  observer.observe(main.querySelector('[data-route-content]') || main.firstElementChild || main);
  const timeout = setTimeout(stop, 2000);
  main.addEventListener('wheel', stop, { once: true });
  main.addEventListener('touchstart', stop, { once: true });
  main.addEventListener('pointerdown', stop, { once: true });
  main.addEventListener('keydown', stop, { once: true });
  return stop;
}
